// import { WorkspaceCreationStatus } from './../../../@types/firestore';
import Onboarding from "components/__haim/NewUserForm/onboarding";
import { UserSettings } from "./../@types/firestore";
import useFirestore from "hooks/useFirestore";
// import NewWorkspaceCreationPage from 'pages/dashboard/NewWorkspaceCreationPage';
import { useState, ReactNode, useMemo, memo } from "react";
import { Navigate, useLocation } from "react-router-dom";
// hooks
// pages
// import Login from '../../pages/authentication/Login';

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: ReactNode;
};

// Users created after this date must accept the terms of service before
// reaching the dashboard, even if they had already completed onboarding.
const termsRequiredAfterDate = new Date("2026-07-28");

const getCreatedDate = (createdTime: UserSettings["createdTime"]): Date | null => {
  if (!createdTime) return null;
  if (createdTime instanceof Date) return createdTime;
  if (typeof createdTime === "string") return new Date(createdTime);
  // Firestore Timestamp
  if (typeof (createdTime as any)?.toDate === "function") return (createdTime as any).toDate();
  return null;
};

const shouldShowOnboarding = (userSettings: UserSettings) => {
  const newOnboardingStartDate = new Date("2024-05-01");
  const createdDate = getCreatedDate(userSettings?.createdTime);

  // For old users, require less information (only phone number)
  if (!createdDate || createdDate < newOnboardingStartDate) {
    return !userSettings?.ownerPhoneNumber;
  }

  // Users created after the terms requirement date must accept the terms of
  // service, even if they had otherwise already completed onboarding.
  if (createdDate > termsRequiredAfterDate && !userSettings?.agreedToTerms) {
    return true;
  }

  return !userSettings?.onboardingCompleted;
};

export default function NewUserGuard({ children }: AuthGuardProps) {
  const { userSettings } = useFirestore();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (!!userSettings && shouldShowOnboarding(userSettings)) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    console.debug("redirecting to new user page");
    return <Onboarding />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
